<template>
  <div class="donation-campaign-card border rounded p-3 mb-3 bg-white" :class="{ 'border-success': settings.is_enabled }">
    <div class="d-flex flex-wrap align-items-start justify-content-between">
      <div class="d-flex align-items-start" style="gap:12px; flex:1; min-width:240px;">
        <div class="donation-icon-wrap">
          <i class="fas fa-heart"></i>
        </div>
        <div>
          <div class="d-flex align-items-center flex-wrap" style="gap:6px;">
            <span class="badge badge-success">Donasi</span>
            <span class="badge" :class="settings.is_enabled ? 'badge-primary' : 'badge-secondary'">
              {{ settings.is_enabled ? 'Aktif' : 'Nonaktif' }}
            </span>
          </div>
          <h5 class="mb-1 mt-2">{{ settings.title || 'Campaign Donasi' }}</h5>
          <p v-if="settings.description" class="text-muted mb-2 small">{{ truncate(settings.description, 120) }}</p>
          <div v-if="settings.is_enabled" class="mb-2">
            <div class="d-flex justify-content-between small mb-1">
              <span>Terkumpul: <b class="text-success">{{ formatRupiah(stats.total_amount) }}</b></span>
              <span v-if="settings.target_amount > 0">{{ progressPct }}%</span>
            </div>
            <div v-if="settings.target_amount > 0" class="progress" style="height:8px;">
              <div class="progress-bar bg-success" :style="{ width: progressPct + '%' }"></div>
            </div>
            <small v-if="settings.target_amount > 0" class="text-muted">
              Target: {{ formatRupiah(settings.target_amount) }} · {{ stats.total_count || 0 }} donatur
            </small>
            <small v-else class="text-muted">{{ stats.total_count || 0 }} donatur</small>
          </div>
          <p v-else class="text-muted small mb-0">Donasi belum diaktifkan. Aktifkan untuk tampil di katalog toko.</p>
        </div>
      </div>
      <div class="d-flex flex-wrap mt-2 mt-md-0" style="gap:6px;">
        <button class="btn btn-sm btn-primary" @click="$emit('edit')">
          <i class="fas fa-edit"></i> {{ settings.is_enabled ? 'Edit' : 'Aktifkan' }}
        </button>
        <router-link v-if="settings.is_enabled" :to="'/shop/' + shopId + '/donations'" class="btn btn-sm btn-outline-info">
          <i class="fas fa-list"></i> Lihat Donasi
        </router-link>
        <button v-if="settings.is_enabled && shopSlug" class="btn btn-sm btn-outline-secondary" @click="copyLink">
          <i class="fas fa-link"></i> Salin Link
        </button>
        <a v-if="settings.is_enabled && shopSlug" :href="'/toko/' + shopSlug + '/donasi'" target="_blank" class="btn btn-sm btn-light">
          <i class="fas fa-external-link-alt"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DonationCampaignCard',
  props: {
    shopId: { type: Number, required: true },
    shopSlug: { type: String, default: '' },
    settings: { type: Object, required: true },
    stats: { type: Object, default: () => ({ total_amount: 0, total_count: 0 }) },
  },
  computed: {
    progressPct() {
      if (!this.settings.target_amount) return 0;
      return Math.min(100, Math.round((this.stats.total_amount || 0) / this.settings.target_amount * 100));
    },
  },
  methods: {
    formatRupiah(v) { return 'Rp ' + (v || 0).toLocaleString('id-ID'); },
    truncate(s, n) { return s && s.length > n ? s.slice(0, n) + '...' : s; },
    copyLink() {
      const url = window.location.origin + '/toko/' + this.shopSlug + '/donasi';
      navigator.clipboard.writeText(url).then(() => {
        this.$toast.success('Link donasi disalin');
      }).catch(() => {
        this.$toast.info(url);
      });
    },
  },
};
</script>

<style scoped>
.donation-icon-wrap {
  width: 56px; height: 56px; border-radius: 12px;
  background: linear-gradient(135deg, #43a047, #66bb6a);
  color: white; display: flex; align-items: center; justify-content: center;
  font-size: 22px; flex-shrink: 0;
}
.donation-campaign-card { box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
</style>
